'use client';
import { Carousel, Typography } from '@curology/ui-components-web/react';
import { DynamicIcon } from '@curology/ui-components-web/react/Icon/DynamicIcon';
import React from 'react';

import { type SurveyDataResource } from '@/services/funnelService/types';

const SurveyResponseCarousel = ({
  surveyResponses,
}: {
  surveyResponses: SurveyDataResource[];
}) => {
  const SurveyDataIcons = () => {
    return surveyResponses.map((response) => (
      <div key={response.name} className="cur-w-[68px]">
        <div className="cur-w-12 cur-h-12 cur-mt-3 cur-mx-auto cur-mb-1">
          <DynamicIcon
            name={response.icon}
            size="xl"
            className="cur-mr-3 cur-flex-shrink-0"
          />
        </div>
        <Typography
          className="cur-text-center cur-mx-1 cur-leading-4"
          weight="bold"
          size="meta"
        >
          {response.formattedName}
        </Typography>
      </div>
    ));
  };
  return (
    <>
      <div className="cur-block sm:cur-hidden cur-w-[calc(100vw-16px)] cur-mt-2">
        {surveyResponses.length > 4 ? (
          <Carousel slidesToShow={4}>{SurveyDataIcons()}</Carousel>
        ) : (
          <div className="cur-flex cur-mx-auto cur-flex-row cur-justify-center">
            <SurveyDataIcons />
          </div>
        )}
      </div>
      <div className="cur-hidden sm:cur-flex cur-mx-auto cur-flex-row cur-justify-center cur-mt-2">
        <SurveyDataIcons />
      </div>
    </>
  );
};

export default SurveyResponseCarousel;
